<template>
  <div class="pb-5">
    <loading v-if="vLoading" />
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
              ><i class="fa fa-arrow-left text-dark"></i
            ></v-btn>
            تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-card>
      <v-card-title>
        <h4>
          ویرایش پکینگ لیست به سفارش {{ packingListInfo.orderCode }}
          <a
            :href="'/factory/order/' + myOrderId"
            class="btn btn-dark"
            target="_blank"
            rel="noopener noreferrer"
            >مشاهده پرونده استعلام
          </a>
        </h4>
      </v-card-title>
      <v-card-text class="py-0 px-2" v-if="packingListInfo.list.length">
        <p>
          لطفا به منظور ویرایش پکینگ لیست، موارد زیر را پر کنید.<br />
          میتوانید تنها برخی از موارد را پر کنید. در صورتی که مایل به حذف یک
          محصول از این پکینگ هستید، کافی است تعداد تحویل این محصول را 0 بگذارید.
          <br />
          پکینگ نهایی قبل از ذخیره سازی از دکمه پایین صفحه به شما نشان داده
          خواهد شد.
        </p>
        <!-- <b-row>
          <b-col cols="2"
            ><b-button
              @click="packingListCalculate(0)"
              variant="warning"
              class="m-2"
              >خالی کردن پکینگ لیست</b-button
            ></b-col
          >
          <b-col cols="2"
            ><b-button
              @click="packingListCalculate(100)"
              variant="warning"
              class="m-2"
              >ارسال کل کالاهای باقیمانده</b-button
            ></b-col
          >
          <b-col cols="2"></b-col>
          <b-col cols="2"></b-col>
          <b-col cols="2"
            ><b-form-input
              v-model="desiredPercentage"
              type="number"
              class="m-2"
              placeholder="درصد ارسال مورد نظر"
            ></b-form-input
          ></b-col>
          <b-col cols="2">
            <b-button
              @click="packingListCalculate(desiredPercentage)"
              variant="warning"
              class="m-2"
              :disabled="!desiredPercentage"
              >ارسال درصد مشخص شده</b-button
            ></b-col
          >
        </b-row> -->

        <b-table
          :busy="tableBusy"
          ref="orderItemsTable"
          responsive
          show-empty
          :items="packingListInfo.list"
          :fields="originalOrderFields"
          empty-text="رکوردی برای نمایش وجود ندارد"
          class="table table-secondary"
          style="font-family: Tahoma !important"
          small
        >
          <template v-slot:head()="data">
            <div dir="ltr" style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div dir="ltr" style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 }}
            </div>
          </template>

          <template v-slot:cell(number)="data">
            <div dir="ltr" style="text-align: center; vertical-align: middle">
              {{ (1 * data.item.number).toLocaleString() }}
            </div>
          </template>
          <template v-slot:cell(notes)="data">
            <div style="text-align: center; vertical-align: middle">
              <div v-html="data.value" v-if="data.value" />
            </div>
          </template>
          <template v-slot:cell(palletNo)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-form-input
                @update="showResultTable = false"
                v-model="data.item.palletNo"
                type="text"
              ></b-form-input>
            </div>
          </template>
          <template v-slot:cell(boxNo)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-form-input
                @update="showResultTable = false"
                v-model="data.item.boxNo"
                type="text"
              ></b-form-input>
            </div>
          </template>
          <template v-slot:cell(netWeight)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-form-input
                @update="showResultTable = false"
                v-model="data.item.netWeight"
                type="text"
              ></b-form-input>
            </div>
          </template>
          <template v-slot:cell(grossWeight)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-form-input
                @update="showResultTable = false"
                v-model="data.item.grossWeight"
                type="text"
              ></b-form-input>
            </div>
          </template>
          <template v-slot:cell(remarks)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-form-input
                @update="showResultTable = false"
                v-model="data.item.remarks"
                type="text"
              ></b-form-input>
            </div>
          </template>
          <template v-slot:cell(packingDescription)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-form-input
                @update="showResultTable = false"
                v-model="data.item.packingDescription"
                type="text"
              ></b-form-input>
            </div>
          </template>
          <template v-slot:cell(packingType)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-form-input
                @update="showResultTable = false"
                v-model="data.item.packingType"
                type="text"
              ></b-form-input>
            </div>
          </template>
          <template v-slot:cell(boxCount)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-form-input
                @update="showResultTable = false"
                v-model="data.item.boxCount"
                type="number"
              ></b-form-input>
            </div>
          </template>
          <template v-slot:cell(qty)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-form-input
                @update="showResultTable = false"
                v-model="data.item.qty"
                type="number"
              ></b-form-input>
            </div>
          </template>
          <template v-slot:cell(priority)="data">
            <div
              dir="ltr"
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma !important;
              "
            >
              {{
                data.value
                  ? priorityOptions.filter((x) => x.value == data.value)[0].text
                  : "--"
              }}
            </div>
          </template>
        </b-table>
        <v-row class="ms-5 my-5 d-flex">
          <span v-show="reactivity"></span>
          <span class="me-5">N</span>
          <v-switch v-model="computedIsComplete"></v-switch>
          <span class="ms-5">K</span>
        </v-row>
        <v-row class="my-3">
          <v-col>
            <span>Packing in: </span>
            <div>
              <v-checkbox
                v-model="packingListInfo.cartonPack"
                label="carton pack"
                color="primary"
                hide-details
              ></v-checkbox>
              <v-checkbox
                v-model="packingListInfo.woodenPack"
                label="wooden pack"
                color="primary"
                hide-details
              ></v-checkbox>
            </div>
          </v-col>
        </v-row>
        <p>یادداشت</p>
        <div class="mb-5 item-ckeditor">
          <ckeditor
            v-model="packingListInfo.description"
            :editor="editor"
            :config="editorConfig"
            @blur="onBlur($event)"
            @focus="onFocus($event)"
            @contentDom="onContentDom($event)"
            @dialogDefinition="onDialogDefinition($event)"
            @fileUploadRequest="onFileUploadRequest($event)"
            @fileUploadResponse="onFileUploadResponse($event)"
          />
        </div>
        <p>توضیحات پکینگ لیست</p>
        <div class="mb-5 item-ckeditor">
          <ckeditor
            v-model="packingListInfo.packingDescription"
            :editor="editor"
            :config="editorConfig"
            @blur="onBlur($event)"
            @focus="onFocus($event)"
            @contentDom="onContentDom($event)"
            @dialogDefinition="onDialogDefinition($event)"
            @fileUploadRequest="onFileUploadRequest($event)"
            @fileUploadResponse="onFileUploadResponse($event)"
          />
        </div>
        <p>آدرس تحویل</p>
        <div class="mb-5 item-ckeditor">
          <ckeditor
            v-model="packingListInfo.address"
            :editor="editor"
            :config="editorConfig"
            @blur="onBlur($event)"
            @focus="onFocus($event)"
            @contentDom="onContentDom($event)"
            @dialogDefinition="onDialogDefinition($event)"
            @fileUploadRequest="onFileUploadRequest($event)"
            @fileUploadResponse="onFileUploadResponse($event)"
          />
        </div>
        <p>دریافت کننده</p>
        <div class="mb-5 item-ckeditor">
          <ckeditor
            v-model="packingListInfo.recieverAgent"
            :editor="editor"
            :config="editorConfig"
            @blur="onBlur($event)"
            @focus="onFocus($event)"
            @contentDom="onContentDom($event)"
            @dialogDefinition="onDialogDefinition($event)"
            @fileUploadRequest="onFileUploadRequest($event)"
            @fileUploadResponse="onFileUploadResponse($event)"
          />
        </div>
        <b-button @click="savePackingList()" variant="primary" class="my-2"
          >مشاهده پکینگ نهایی</b-button
        >

        <b-table
          v-if="showResultTable"
          responsive
          show-empty
          :items="finalPackingListItems"
          :fields="originalOrderFields"
          empty-text="رکوردی برای نمایش وجود ندارد"
          class="table"
          style="font-family: Tahoma !important"
          small
        >
          <template v-slot:head()="data">
            <div
              dir="ltr"
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma !important;
              "
            >
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div
              dir="ltr"
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma !important;
              "
            >
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div
              style="
                text-align: center;
                vertical-align: middle;
                font-family: Tahoma !important;
              "
            >
              {{ data.index + 1 }}
            </div>
          </template>
        </b-table>
      </v-card-text>
      <v-card-text class="py-0 px-2" v-else>
        <h3>
          امکان ویرایش پکینگ لیست وجود ندارد. چرا که کلیه اقلام این سفارش قبلا
          در پکینگ‌های قبل ثبت شده است.
        </h3>
      </v-card-text>
      <v-card-actions class="p-3 mr-3">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :disabled="!showResultTable || !finalPackingListItems.length"
          @click="submitPackingList()"
        >
          ویرایش پکینگ لیست
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Axios from "axios";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { CKEditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import router from "../../router";
import moment from "moment-jalaali";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    CKEditor,
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "subscript",
          "superscript",
          "fontColor",
        ],
        height: 200,
        language: 'fa',
        contentsLangDirection: 'rtl',
      },
      guide: false,
      isBusy: false,
      showResultTable: false,
      valueWhenIsEmpty: "",
      options: {
        decimal: ",",
        thousands: ",",
        precision: 0,
        length: 16,
      },
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },
      showProgress: false,
      uploadButDisable: false,
      variant: "info",
      striped: true,
      max: 100,
      uploadPercentage: 0,
      isUploaded: false,
      file: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      uploadedFiles: [],
      packingListInfo: {
        list: [],
        woodenPack: false,
        cartonPack: false,
      },
      finalPackingListItems: [],
      tableBusy: true,
      originalOrderFields: [
        // { key: "itemCode", label: "شماره سفارش" },
        // { key: "type", label: "نوع کالا" },
        // { key: "priority", label: "اولویت" },
        // { key: "notes", label: "توضیحات تکمیلی" },
        { key: "palletNo", label: "شماره پالت" },
        { key: "boxNo", label: "شماره جعبه" },
        { key: "netWeight", label: "وزن خالص" },
        { key: "grossWeight", label: "وزن غیرخالص" },
        { key: "remarks", label: "نکات تکمیلی" },
        { key: "packingDescription", label: "توضیحات بسته‌بندی" },
        { key: "packingType", label: "نوع بسته‌بندی" },
        { key: "boxCount", label: "تعداد جعبه" },
        { key: "qty", label: "تعداد تحویل" },
        { key: "previousQTY", label: "تعداد قبلی" },
        { key: "number", label: "تعداد کل" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "coating", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "mapNumber", label: "شماره نقشه" },
        { key: "customerIndex", label: " ردیف مشتری" },
        { key: "index", label: "ردیف" },
      ],
      priorityOptions: [
        {
          value: "low",
          text: "پایین",
        },
        {
          value: "normal",
          text: "معمولی",
        },
        {
          value: "high",
          text: "بالا",
        },
        {
          value: "urgent",
          text: "اورژانسی",
        },
      ],
      packageOptions: [
        {
          value: "کارتن یا پالت چوبی",
          text: "کارتن یا پالت چوبی",
        },
        {
          value: "پالت فلزی",
          text: "پالت فلزی",
        },
        {
          value: "صندوق چوبی",
          text: "صندوق چوبی",
        },
        {
          value: "سایر",
          text: "سایر",
        },
      ],
      myPackingListId: "",
      myOrderId: "",
      desiredPercentage: "",
      reactivity: false,
    };
  },
  computed: {
    computedIsComplete() {
      let complete = false;
      let packingListData = this.packingListInfo.list
        .map((a) => {
          return a.number - a.previousQTY;
        })
        .reduce((a, b) => a + b);
      let remainData = this.packingListInfo.list
        .map((a) => Number(a.qty))
        .reduce((a, b) => a + b);
      if (packingListData == remainData) {
        this.reactivity = !this.reactivity;
        complete = true;
      } else {
        this.reactivity = !this.reactivity;
        complete = false;
      }
      return complete;
    },
  },
  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    packingListEmpty() {
      this.tableBusy = true;
      this.packingListInfo.list.forEach((element) => {
        element.qty = 0;
      });
      setTimeout(() => {
        this.tableBusy = false;
      }, 500);
    },
    packingListFull() {
      this.tableBusy = true;
      this.packingListInfo.list.forEach((element) => {
        element.qty = Number(element.number) - Number(element.previousQTY);
      });
      setTimeout(() => {
        this.tableBusy = false;
      }, 500);
    },
    packingListCalculate(percentage) {
      if (percentage > 100)
        this.toast(
          "درصد انتخابی بیشتر از 100 است. لطفا عددی بین 0 تا 100 انتخاب کنید.",
          "error"
        );
      else if (percentage < 0)
        this.toast(
          "درصد انتخابی منفی است. لطفا عددی بین 0 تا 100 انتخاب کنید.",
          "error"
        );
      else {
        this.tableBusy = true;
        this.packingListInfo.list.forEach((element) => {
          element.qty = parseInt(
            ((Number(element.number) - Number(element.previousQTY)) *
              percentage) /
              100
          );
        });
        setTimeout(() => {
          this.tableBusy = false;
        }, 500);
      }
    },
    savePackingList() {
      this.showResultTable = false;
      this.finalPackingListItems = this.packingListInfo.list.filter((x) =>
        Number(x.qty)
      );
      setTimeout(() => {
        this.showResultTable = true;
      }, 500);
    },
    showPackingList() {
      this.vLoading = true;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/factory/packinglist/getInfo",
        {
          packingListId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.packingListInfo = res.data;
            this.myOrderId = this.packingListInfo.orderId;
            this.showResultTable = false;
            this.tableBusy = false;
            this.vLoading = false;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    submitPackingList() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/factory/packingList/edit",
        {
          packingListId: this.$route.params.id,
          description: this.packingListInfo.description,
          packingDescription: this.packingListInfo.packingDescription,
          address: this.packingListInfo.address,
          recieverAgent: this.packingListInfo.recieverAgent,
          list: this.finalPackingListItems,
          isComplete: this.computedIsComplete,
          woodenPack: this.packingListInfo.woodenPack,
          cartonPack: this.packingListInfo.cartonPack,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.toast("بسته‌بندی با موفقیت ثبت شد.", "success");
            this.showPackingList();
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            this.vLoading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    onBlur(evt) {},
    onFocus(evt) {},
    onContentDom(evt) {},
    onDialogDefinition(evt) {},
    onFileUploadRequest(evt) {},
    onFileUploadResponse(evt) {},
  },
  mounted() {
    this.myPackingListId = this.$route.params.id;
    this.showPackingList();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
